// @react-functional
function getPartyCategory(selectorParty?: {
  name?: string;
  type?: string;
}): string {
  if (!selectorParty) return '';

  let partyCategory;

  if (selectorParty.name) {
    partyCategory = selectorParty.name;
  } else if (selectorParty.type === 'PP') {
    partyCategory = 'Personne physique';
  } else {
    partyCategory = 'Personne morale';
  }

  return partyCategory;
}

export function getParties(searchQuery: {
  party?: { name?: string; type?: string } | null;
  otherParty?: { name?: string; type?: string } | null;
}): string {
  const party = searchQuery.party ? getPartyCategory(searchQuery.party) : '';
  const otherParty = searchQuery.otherParty
    ? getPartyCategory(searchQuery.otherParty)
    : '';

  if (party && otherParty) {
    return `Parties : ${party} contre ${otherParty}`;
  }
  if (party) {
    return `Parties : ${party}`;
  }
  if (otherParty) {
    return `Parties : ${otherParty}`;
  }

  return '';
}
